module.exports = __webpack_public_path__ + "static/crystal-palace-92477518bd4c39d66f88a4901e8ba5d2.jpg";